import { atom } from "jotai";

/**
 * Interface representing a message received from the server.
 * Used for notifications, alerts, and other server communications.
 */
export interface ServerMessage {
  recievedTime: Date; // Timestamp when the message was received
  messageType: string; // Type of message (e.g., "error", "success", "info")
  timeStamp: string; // Timestamp from the server
}

/**
 * Jotai atom for storing server messages.
 * Maintains a list of messages received from the server.
 * Initial state is an empty array.
 */
export const MessageStateAtom = atom<ServerMessage[]>([]);
